import intersect from '@alpinejs/intersect'
import Alpine from 'alpinejs'
import '@animxyz/core'
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import axios from 'axios';
import './formSubmission';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin); 

gsap.config({
  nullTargetWarn: false
});

Alpine.plugin(intersect)
window.Alpine = Alpine
window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
Alpine.start();

let tl = gsap.timeline({})
var logo = document.querySelector("#logo");
var logotype = document.querySelector("#logotype");

gsap.set(logo, {
  top: "46.8%"
});

tl.to(logo, {		 
  scrollTrigger: {
    trigger: "#scroll-container",
    invalidateOnRefresh: true,
    start: "top 46%",
    end: "top 0",
    markers: false,
    //pin: true,
    //pinSpacing: false,
    scrub: 0
  },
  top: 0,
  scaleX:0.4, 
  scaleY:0.4,
  ease: "none",
  duration: 1
});

gsap.set(logotype, {
  opacity: "1"
});

tl.to(logotype, {		 
  scrollTrigger: {
    trigger: "#scroll-container",
    invalidateOnRefresh: true,
    start: "top 50%",
    end: "top 46%",
    markers: false,
    scrub: 0
  },
  opacity: 0,
  ease: "none",
  duration: 1
});

let container = document.querySelector(".panels-wrapper");

const panels = gsap.utils.toArray(".panel");

gsap.to(container, {
    x: () => -(container.scrollWidth - document.documentElement.clientWidth) + "px",
    ease: "none",
    scrollTrigger: {
        trigger: container,
        invalidateOnRefresh: true,
        pin: true,
        scrub: 1,
        end: () => "+=" + container.offsetWidth,
    }
});

function getSamePageAnchor (link) {
  if (
    link.protocol !== window.location.protocol ||
    link.host !== window.location.host ||
    link.pathname !== window.location.pathname ||
    link.search !== window.location.search
  ) {
    return false;
  }

  return link.hash;
}

function scrollToHash(hash, e) {
  const elem = hash ? document.querySelector(hash) : false;
  if(elem) {
    if(e) e.preventDefault();
    gsap.to(window, {scrollTo: elem});
  }
}

document.querySelectorAll('a[href]').forEach(a => {
  a.addEventListener('click', e => {
    scrollToHash(getSamePageAnchor(a), e);
  });
});

scrollToHash(window.location.hash);

function resetHeight(){
  document.body.style.height = window.innerHeight + "px";
}
window.addEventListener("resize", resetHeight);
resetHeight();


function hideVideo() {
  var triggerElement = document.getElementById('video_trigger');
  if (triggerElement.getBoundingClientRect().top <= 0) {
    // console.log("hide video");
    document.body.classList.add('offvideo')
  } else {
    document.body.classList.remove('offvideo')
  }
}

window.addEventListener('scroll', hideVideo);




